import { render, staticRenderFns } from "./tenant-list.vue?vue&type=template&id=022be393&scoped=true"
import script from "./tenant-list.vue?vue&type=script&lang=ts"
export * from "./tenant-list.vue?vue&type=script&lang=ts"
import style0 from "./tenant-list.vue?vue&type=style&index=0&id=022be393&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022be393",
  null
  
)

export default component.exports